<template>
  <div class="container p-5 mt-5 mb-5">
    <div class="d-flex flex-row justify-content-between flex-wrap">
      <h2 class="text-bg">{{ pageTitle }}</h2>
      <n-button type="info" size="medium" style="font-size: 20px" @click="$router.back()">
        <i class="icon-arrow-left" style="padding-right: 12px"></i>
        REGRESAR
      </n-button>
    </div>
    <n-form size="large" label-placement="top" :rules="rules" ref="formRef" :model="model">
      <div class="mt-5 mb-3">
        <n-form-item label="Nombre" path="name">
          <n-input type="text" id="inputName" v-model:value="model.name" placeholder="Ingrese el nombre del suministro" />
        </n-form-item>
      </div>

      <div class="mb-3">
        <n-form-item label="Proveedor" path="provider">
          <n-select v-model:value="model.provider" :options="providerOptions" placeholder="Seleccione un proveedor" />
        </n-form-item>
      </div>

      <n-form-item label="Formato" path="format">
        <n-radio-group v-model:value="model.format" name="format">
          <n-space>
            <n-radio @change="handleRadioValueChange" :checked="model.format === 'kg'" value="kg"> Kg </n-radio>
            <n-radio @change="handleRadioValueChange" :checked="model.format === 'g'" value="g"> G </n-radio>
            <n-radio @change="handleRadioValueChange" :checked="model.format === 'l'" value="l"> L </n-radio>
            <n-radio @change="handleRadioValueChange" :checked="model.format === 'ton'" value="ton"> Ton </n-radio>
          </n-space>
        </n-radio-group>
      </n-form-item>

      <div class="mb-4 form-group">
        <n-h3 style="font-weight: 700">Presentación</n-h3>
        <div class="mb-3">
          <n-form-item label="Descripción" path="description">
            <n-input type="text" id="inputFormat" v-model:value="model.description" placeholder="Ingrese una descripción " />
          </n-form-item>
        </div>

        <div class="mb-3">
          <n-form-item label="Cantidad total" path="totalAmountInFormatUnit">
            <n-input-number
              number
              type="text"
              :show-button="false"
              id="inputFormat"
              v-model:value="model.totalAmountInFormatUnit"
              placeholder="Ingrese una cantidad total"
              class="w-100"
              min="1"
            />
          </n-form-item>
        </div>
      </div>

      <div class="mb-4 form-group">
        <n-h3 style="font-weight: 700">Precio</n-h3>
        <div class="mb-3">
          <n-form-item label="Por formato" path="perFormat">
            <n-input
              type="text"
              :show-button="false"
              id="inputFormat"
              v-model:value="model.perFormat"
              placeholder="Ingrese un precio por formato"
              @change="updatePresentationPrice($event)"
              class="w-100"
            />
          </n-form-item>
        </div>

        <div class="mb-3">
          <n-form-item label="Por presentación" path="perPresentation">
            <n-input
              type="text"
              :show-button="false"
              id="inputFormat"
              v-model:value="model.perPresentation"
              placeholder="Ingrese un precio por presentación"
              @change="updatePerFormatPrice($event)"
              class="w-100"
            />
          </n-form-item>
        </div>
      </div>

      <div class="mb-3">
        <div class="form-check form-switch">
          <input class="form-check-input" type="checkbox" id="flexSwitchCheckDisabled" @change="switchIsAvailable($event)" :checked="isAvailable" />
          <label class="form-check-label" for="flexSwitchCheckDisabled">{{ isAvailable ? "Suministro disponible" : "Suministro no disponible" }}</label>
        </div>
      </div>

      <div class="d-flex justify-content-center">
        <n-button type="info" class="text-center w-100" @click="submitForm" style="font-size: 20px">
          <i class="icon-plus" style="padding-right: 12px"></i>
          {{ submitButtonText }}
        </n-button>
      </div>
    </n-form>
  </div>
</template>

<script>
import { mapActions, mapState } from "pinia";
import { useMessage } from "naive-ui";
import supplyStore from "../../store/supply";
import providerStore from "../../store/provider";
import authStore from "../../store/auth";
import seedStore from "../../store/seed";

export default {
  props: {
    pageTitle: String,
    supplyType: String,
    submitButtonText: String,
    editMode: Boolean,
    cloneMode: Boolean,
  },
  data() {
    return {
      priceToStore: {
        perFormat: null,
        perPresentation: null,
      },
      formRef: null,
      model: {
        name: null,
        provider: null,
        format: null,
        description: null,
        totalAmountInFormatUnit: null,
        perFormat: null,
        perPresentation: null,
      },
      rules: {
        name: {
          required: true,
          trigger: "blur",
          message: "Por favor ingrese un nombre",
        },
        provider: {
          required: true,
          trigger: "blur",
          message: "Por favor ingrese un proveedor",
        },
        format: {
          required: true,
          trigger: "blur",
          message: "Por favor ingrese un formato",
        },
        description: {
          required: true,
          trigger: "blur",
          message: "Por favor ingrese una descripción",
        },
        totalAmountInFormatUnit: {
          required: true,
          trigger: "blur",
          validator(rule, value) {
            if (!value) {
              rule.message = "Por favor ingrese una cantidad total";
              return false;
            } else return true;
          },
        },
        perFormat: {
          required: true,
          validator(rule, value) {
            if (!value) {
              rule.message = "Por favor ingrese un precio por formato";
              return false;
            } else return true;
          },
          trigger: "blur",
        },
        perPresentation: {
          required: true,
          trigger: "blur",
          validator(rule, value) {
            if (!value) {
              rule.message = "Por favor ingrese un precio por presentacion";
              return false;
            } else return true;
          },
        },
      },
      providerOptions: [],
      seedOptions: [],
      message: useMessage(),
      isTheFormValid: true,
      isAvailable: true,
    };
  },
  async created() {
    await this.getAllProviders();
    const filteredProviders = this.providers.filter(provider => {
      return provider.type.find(type => {
        if (type === this.supplyType) {
          provider.label = provider.name;
          provider.value = provider._id;
          return true;
        }
      });
    });
    this.providerOptions = filteredProviders;
    if (this.editMode) {
      await this.preLoadData(this.$route.params.id);
    } else if (this.cloneMode) {
      this.model.name = `${this.supplyToBeCloned.name} (copia)`;
      this.model.provider = this.supplyToBeCloned.provider?._id;
      this.model.format = this.supplyToBeCloned.format;
      this.model.description = this.supplyToBeCloned.presentation?.description;
      this.model.totalAmountInFormatUnit = this.supplyToBeCloned.presentation?.totalAmountInFormatUnit;
      this.model.perFormat = this.supplyToBeCloned.price?.perFormat;
      this.model.perPresentation = this.supplyToBeCloned.price?.perPresentation;
      this.isAvailable = this.supplyToBeCloned.isAvailable;
    }
  },
  mounted() {},
  computed: {
    ...mapState(providerStore, ["providers"]),
    ...mapState(seedStore, ["seeds"]),
    ...mapState(supplyStore, ["supplies", "supplyToBeCloned"]),
    ...mapState(authStore, ["isLoggedIn"]),
  },
  methods: {
    ...mapActions(providerStore, ["getAllProviders"]),
    ...mapActions(seedStore, ["getSeeds"]),
    ...mapActions(supplyStore, ["createSupply", "getSuppliesById"]),
    async preLoadData(id) {
      let supply = await this.getSuppliesById(id);
      this.model.name = supply.name;
      this.model.provider = supply.provider;
      this.model.format = supply.format;
      this.model.description = supply.presentation.description;
      this.model.totalAmountInFormatUnit = supply.presentation.totalAmountInFormatUnit;
      this.model.perFormat = supply.price.perFormat;
      this.model.perPresentation = supply.price.perPresentation;
      this.isAvailable = supply.isAvailable;
      return supply;
    },
    switchIsAvailable(e) {
      this.isAvailable = e.target.checked;
    },
    replaceCommaWithDot(string) {
      string = string.toString();
      return Number(string.replace(/,/g, "."));
    },
    turnAllNumbersPositive() {
      this.model.totalAmountInFormatUnit = Math.abs(this.model.totalAmountInFormatUnit);
      this.model.perFormat = Math.abs(this.model.perFormat);
      this.model.perPresentation = Math.abs(this.model.perPresentation);
      this.priceToStore.perFormat = Math.abs(this.priceToStore.perFormat);
      this.priceToStore.perPresentation = Math.abs(this.priceToStore.perPresentation);
    },
    handleRadioValueChange(e) {
      this.model.format = e.target.value;
    },
    updatePerFormatPrice(e) {
      e = this.replaceCommaWithDot(e);
      if (!this.model.totalAmountInFormatUnit && !this.model.perPresentation) {
        this.message.info(
          "Cantidad total por presentación y precio por presentación son campos requeridos para calcular precio por formato. No pueden estar vacíos",
          { duration: 10000 }
        );
      } else {
        if (!e) {
          this.priceToStore.perFormat = null;
          this.model.perFormat = null;
        } else {
          this.model.perPresentation = e;
          this.priceToStore.perPresentation = e;
          this.priceToStore.perFormat = e / this.model.totalAmountInFormatUnit;
          this.model.perFormat = Number(this.priceToStore?.perFormat?.toFixed(2));
        }
      }
      this.turnAllNumbersPositive();
    },
    updatePresentationPrice(e) {
      e = this.replaceCommaWithDot(e);
      if (!this.model.totalAmountInFormatUnit && !this.model.perFormat) {
        this.message.info(
          "Cantidad total por presentación y precio por formato son campos requeridos para calcular precio por presentación. No pueden estar vacíos",
          { duration: 10000 }
        );
      } else {
        if (!e) {
          this.priceToStore.perPresentation = null;
          this.model.perPresentation = null;
        } else {
          this.model.perFormat = e;
          this.priceToStore.perFormat = e;
          this.priceToStore.perPresentation = e * this.model.totalAmountInFormatUnit;
          this.model.perPresentation = Number(this.priceToStore?.perPresentation?.toFixed(2));
        }
      }
      this.turnAllNumbersPositive();
    },
    compareCloneToOrigina() {
      let sameName = this.model.name == this.supplyToBeCloned.name;
      let sameProvider = this.model.provider == this.supplyToBeCloned.provider._id;
      let sameFormat = this.model.format == this.supplyToBeCloned.format;
      let sameDescription = this.model.description == this.supplyToBeCloned.presentation.description;
      let sameTotalAmountInFormatUnit = this.model.totalAmountInFormatUnit == this.supplyToBeCloned.presentation.totalAmountInFormatUnit;
      let samePricePerFormat = this.model.perFormat == this.supplyToBeCloned.price.perFormat;
      let samePricePerPresentation = this.model.perPresentation == this.supplyToBeCloned.price.perPresentation;
      let sameAvailabilityStatus = this.isAvailable == this.supplyToBeCloned.isAvailable;

      if (
        sameName &&
        sameProvider &&
        sameFormat &&
        sameDescription &&
        sameTotalAmountInFormatUnit &&
        samePricePerFormat &&
        samePricePerPresentation &&
        sameAvailabilityStatus
      ) {
        return true;
      }
    },
    validateForm() {
      const { name, provider, format, description, totalAmountInFormatUnit, perFormat, perPresentation } = this.model;
      this.$refs.formRef.validate();
      if (!name) {
        this.message.error("Por favor ingrese un nombre");
        this.isTheFormValid = false;
      }
      if (!provider) {
        this.message.error("Por favor seleccione un proveedor");
        this.isTheFormValid = false;
      }
      if (!format) {
        this.message.error("Por favor ingrese un formato");
        this.isTheFormValid = false;
      }
      if (!description) {
        this.message.error("Por favor ingrese una descripcion");
        this.isTheFormValid = false;
      }
      if (!totalAmountInFormatUnit) {
        this.message.error("Por favor ingrese una cantidad total");
        this.isTheFormValid = false;
      }
      if (!perFormat) {
        this.message.error("Por favor ingrese un precio por formato");
        this.isTheFormValid = false;
      }
      if (!perPresentation) {
        this.message.error("Por favor ingrese un precio por presentacion");
        this.isTheFormValid = false;
      }

      if (this.cloneMode && this.compareCloneToOrigina()) {
        this.message.error("El clon no puede ser igual al original");
        this.isTheFormValid = false;
      }
    },
    submitForm() {
      this.validateForm();
      const { name, provider, format, description, totalAmountInFormatUnit, perFormat, perPresentation } = this.model;

      if (this.isTheFormValid) {
        let data = {
          name: name,
          provider: provider,
          format: format,
          presentation: {
            description,
            totalAmountInFormatUnit,
          },
          price: {
            perFormat: this.priceToStore.perFormat || perFormat,
            perPresentation: this.priceToStore.perPresentation || perPresentation,
          },
          type: this.supplyType,
          isAvailable: this.isAvailable,
        };

        this.$emit("dataFormValid", data);
      }

      this.isTheFormValid = true;
    },
  },
};
</script>
